export const socialLinks = [
  {
    name: 'IMDb',
    href: 'https://www.imdb.com/name/nm4728214/',
    icon: '/SocialIcons/IMDb_icon.webp',
    type: 'image'
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/soundandmelodies/',
    icon: '/SocialIcons/Instagram_icon.avif',
    type: 'image'
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100063487271266',
    icon: '/SocialIcons/Facebook_icon.avif',
    type: 'image'
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@SoundandMelodies',
    icon: '/SocialIcons/Youtube_icon.avif',
    type: 'image'
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/sangampanta/',
    icon: '/SocialIcons/Linkedin_icon.avif',
    type: 'image'
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@soundandmelodies',
    icon: '/SocialIcons/TikTok_icon.avif',
    type: 'image'
  },
  {
    name: 'Spotify',
    href: 'https://open.spotify.com/artist/2wkgc34vIaza0REYBm8hcG?si=jy6dacPmR5SQku6qXftEOw',
    icon: '/SocialIcons/Spotify_icon.avif',
    type: 'image'
  },
  {
    name: 'Apple Music',
    href: 'https://music.apple.com/us/artist/pushpasangam/1547971247',
    icon: '/SocialIcons/AppleMusic_icon.webp',
    type: 'image'
  },
  {
    name: 'Amazon Music',
    href: 'https://music.amazon.com/artists/B08SHP5PRK/pushpasangam',
    icon: '/SocialIcons/AmazonMusic_icon.webp',
    type: 'image'
  }
];

export type NavigationItem = {
  name: string;
  href: string;
  children?: NavigationItem[];
};

export const navigation: NavigationItem[] = [
  {
    name: 'Home',
    href: '/'
  },
  {
    name: 'Credits',
    href: '/credits'
  },
  {
    name: 'Music',
    href: '/music'
  },
  {
    name: 'Utilities',
    href: '#',
    children: [
      {
        name: 'DCP Tool',
        href: '/dcp-tool'
      },
      {
        name: 'Timecode Notes',
        href: '/timecode-notes'
      },
      {
        name: 'Cinemmerse Pro',
        href: '/cinemmerse-pro'
      },
      {
        name: 'SoundLibraryExplorer',
        href: '/sound-library-explorer'
      }
    ]
  },
  {
    name: 'Downloads',
    href: '/downloads'
  },
  {
    name: 'Contact',
    href: '/contact'
  }
];

export const downloads = [
  {
    id: 1,
    name: 'Pro Tools 5.1 Post Production Template',
    description: 'This 5.1 Pro Tools template includes all core sections—Video, Dialogues, Ambience, Foley, SFX, Sound Design, Music, plus Print stems. Each group has its own BUS, routed through a Submaster to the Master, with all tracks and buses color‑coded for fast, organized workflow. Click \'Watch Video\' button below to see how the template is structured.',
    fileSize: '559 KB',
    link: '/01-WebsiteFiles/Download/PT-PostProductionTemplate-5.1-SangamPanta.com-5Sep2025.zip'
  },
  {
    id: 2,
    name: 'Pro Tools 7.1.4 Dolby Atmos Post Production Template',
    description: 'My custom 7.1.4 surround sound Pro Tools template, built using Dolby‑recommended track layouts, includes fully organized stem groups, mono, stereo, and 5.1 delay and reverb effect sends, as well as four dedicated stem beds—Dialogue, Ambience, Effects, and Music—all color‑coded for an efficient and intuitive workflow. Please note that object tracks are not included and can be added from Dolby Atmos tab in Pro Tools Setup I/O as needed for your specific project.',
    fileSize: '596 KB',
    link: '/01-WebsiteFiles/Download/PT-7.1.4-AtmosTemplate-sangampanta.com.zip'
  },
  {
    id: 3,
    name: 'Production Sound Checklist',
    description: 'Comprehensive checklist for preparing audio gear setup for production.',
    fileSize: '66 KB',
    link: '/01-WebsiteFiles/Download/ProductionSoundStartupChecklist.pdf'
  },
  {
    id: 4,
    name: 'Chord Formula and Related Chords Chart',
    description: 'An easy to read chart with musical chords, related chords, modes, and scales.',
    fileSize: '178 KB',
    link: '/01-WebsiteFiles/Download/Chord Formula and Related Chords-SangamPanta.pdf'
  }
];
